// import { Edit } from "@mui/icons-material";
// import { IconButton } from "@mui/material";
// import AppAvatar from "components/avatars/AppAvatar";
import DateRangeWorkshop from 'utils/DateRangeWorkshop';
// import FormatDate from "utils/formatDate";
const columnShape = [
    // {
    // Header: "Avatar",
    // accessor: "avatar",
    // Cell: ({
    //   value
    // }) => <AppAvatar src={value} sx={{
    //   borderRadius: "20%"
    // }} />
    // },
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: 'Type',
        accessor: 'workshop_type.name',
    },
    {
        Header: 'Date',
        accessor: 'mapping_ws_to_time_slot',
        Cell: ({ value }) => DateRangeWorkshop(value),
    },
    // {
    //   Header: "Edit",
    //   accessor: "edit",
    //   Cell: props => {
    //     return <IconButton>
    //           <Edit sx={{
    //         color: "text.disabled",
    //         fontSize: 18
    //       }} />
    //         </IconButton>;
    //   }
    // }
];
export default columnShape;
